import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { AttendeeSessionService } from "../../../../modules/shared/services/attendee-session.service";
import { CclPopupService, CclMessageService } from "certain-common-library";
import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from "@angular/router";
import { CatalogService } from "../../../../modules/shared/services/catalog.service";

@Component({
    selector: "forgot-password",
    templateUrl: "./forgot-password.view.html",
    providers: []
})
export class ForgotPasswordView implements OnInit {
    forgotPasswordModal: any = {};
    loginConfig: any = {};
    isPopUp: boolean = false;
    constructor(
        private router: Router,
        public sharedService: SharedService,
        private attendeeSessionService: AttendeeSessionService,
        private popupService: CclPopupService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService
    ) {}

    ngOnInit() {
        this.isPopUp = this.router.url.includes("(popup:popup/forgotPassword)");
        this.loginConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP].config);        
    }

    close() {
        this.popupService.hidePopup();
    }

    openPopup(item, $event) {
        this.popupService.hidePopup();
        setTimeout(() => {
            if ($event != null) {
                $event.stopPropagation();
            }
            let url = "";
            this.popupService.setPosition("center");
                this.popupService.setHeight("50%");
                this.popupService.setSize("small");
                this.popupService.togglePopup();
            if (item == "login") {
                this.sharedService.currentPopup = {
                    title: null,
                    navLinks: null,
                    saveMessage: "reg-login",
                    showFooter: false
                };
                url = "popup/login";
            } else if(item == "resetPassword") {
                this.sharedService.currentPopup = {
                    title: null,
                    navLinks: null,
                    saveMessage: "resetPass",
                    showFooter: false
                };
                url = "popup/resetPassword";
            }
            this.sharedService.navigateToOutlet("popup", url);
        }, 500);
    }

    sendEmail() {
        if(this.forgotPasswordModal.email) {
            this.forgotPasswordModal.eventId = this.sharedService.event.id;
            this.attendeeSessionService.forgotPassword(this.forgotPasswordModal,window.location.href.includes("preview") ? "true" : "").subscribe((response) => {
                this.popupService.hidePopup();
                if(response['body']['data'].message) {
                    this._flashMessagesService.show(response['body']['data'].message, {
                        cssClass: "alert-success"
                    });
                }
            },
            (err) => {
                var message = "";
                if (err.error.errorResponse != null && err.error.errorResponse.errors != null) {
                    err.error.errorResponse.errors.forEach((element) => {
                        message += element + "\n";
                    });
                }

                this._flashMessagesService.show(message, {
                    cssClass: "alert-danger"
                });
            })
        } else {
            this._flashMessagesService.show("Email/Username is required", {
                    cssClass: "alert-danger"
            });
        }
    }
}
